/**
 * đơn vị tính
 * tvanh 21.03.2024
 */
export default {
  One: 0,
  Thousand: 1,
  Million: 2,
  Billion: 3,
};